import { SkullCrossbonesOutlineIcon } from './SkullCrossbonesOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 5DBA18AE-EED4-4F73-A0FD-ACC5E731A70C
 * name skull-crossbones-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skull-crossbones-outline.svg
 * tags
 * - Gaming / RPG 
 * - Holiday 
 */
export const JollyRogerOutlineIcon = SkullCrossbonesOutlineIcon;
export default JollyRogerOutlineIcon